module.exports = __webpack_public_path__ + "static/media/altimage.855e8ca0.jpg";